// extracted by mini-css-extract-plugin
module.exports = {"container":"FormTextSeparator_container__16xVR","text":"FormTextSeparator_text__29epx"};